import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomPreferencesRoundedIcon from '@mui/icons-material/RoomPreferencesRounded';
import PasswordRoundedIcon from '@mui/icons-material/PasswordRounded';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import LockResetRoundedIcon from '@mui/icons-material/LockResetRounded';
import EditModal from "../../../components/editModal/editModal";
import ChangePassword from "../../../components/changePassword/changePassword";
import ChangeUserPermissions from "../../../components/changeUserPermissions/changeUserPermissions";
import useEntity from "../../../api/useEntity";
import moment from "moment/moment";
import "./users.scss"

const Users = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [changePassword, setChangePassword] = useState(false);
    const [changeAccessRights, setChangeAccessRights] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/users");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "users",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    const newUser = item.id === undefined;

    return (
        <div className="users">
            <button className="add" onClick={() => setSelectedItem(true)}>Benutzer hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Benutzername</th>
                            <th>Name</th>
                            <th>E-Mail</th>
                            <th>Rolle</th>
                            <th>Startseite</th>
                            <th style={{width: "160px"}}>Zuletzt online</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((user) => (
                            <tr key={user.id}>
                                <td>{user.username}</td>
                                <td>{user.name} {user.surname}</td>
                                <td>{user.email}</td>
                                <td>{user.role}</td>
                                <td>{user.landingPage}</td>
                                <td title={moment(user.lastOnline).calendar()}>{user.lastOnline ? moment(user.lastOnline).fromNow() : null}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(user.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem && (
                <EditModal
                    title="Benutzer"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <PermIdentityOutlinedIcon />
                        <input
                            type="username"
                            name="username"
                            placeholder="Benutzername"
                            value={item.username}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    username: e.target.value
                                }))
                            }
                        />
                    </div>
                    {newUser &&
                        <div className="group">
                            <LockOutlinedIcon />
                            <input
                                type="password"
                                name="password"
                                placeholder="Passwort"
                                value={item.password}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        password: e.target.value
                                    }))
                                }
                            />
                        </div>
                    }
                    {!newUser &&
                        <div className="group">
                            <BadgeOutlinedIcon />
                            <input
                                type="text"
                                name="name"
                                placeholder="Vorname"
                                value={item.name || ""}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        name: e.target.value
                                    }))
                                }
                            />
                            <input
                                type="text"
                                name="surname"
                                placeholder="Nachname"
                                value={item.surname || ""}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        surname: e.target.value
                                    }))
                                }
                            />
                        </div>
                    }
                    <div className="group">
                        <EmailOutlinedIcon />
                        <input
                            type="email"
                            name="email"
                            placeholder="E-Mail"
                            value={item.email || ""}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    email: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <LockPersonOutlinedIcon />
                        <select
                            type="text"
                            value={item.role}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    role: e.target.value
                                }))
                            }
                        >
                            <option value="admin">admin</option>
                            <option value="user">user</option>
                            <option value="operator">operator</option>
                            <option value="company">company</option>
                        </select>
                    </div>
                    {!newUser &&
                        <div className="group">
                            <ManageAccountsIcon />
                            <input
                                type="number"
                                name="employeeId"
                                placeholder="Ergo Mitarbeiter ID"
                                value={item.employeeId || ""}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        employeeId: Number(e.target.value)
                                    }))
                                }
                            />
                        </div>
                    }
                    {!newUser &&
                        <div className="group">
                            <ApartmentIcon />
                            <input
                                type="number"
                                name="companyId"
                                placeholder="Ergo Kunden ID"
                                value={item.companyId || ""}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        companyId: Number(e.target.value)
                                    }))
                                }
                            />
                        </div>
                    }
                    {!newUser &&
                        <div className="group">
                            <RoomPreferencesRoundedIcon />
                            <input
                                type="text"
                                name="landingPage"
                                placeholder="Startseite"
                                value={item.landingPage || ""}
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        landingPage: e.target.value
                                    }))
                                }
                            />
                        </div>
                    }
                    <div className="group" onClick={() =>
                        setItem(prev => ({
                            ...prev,
                            mfaEnabled: !prev.mfaEnabled
                        }))
                    }>
                        <PasswordRoundedIcon />
                        <div className="checkbox">
                            <div className="box">
                                <div className={item.mfaEnabled ? "check on" : "check"} />
                            </div>
                            <span>Multi-Faktor-Authentifizierung</span>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                            <button type="button" className="light" onClick={() => setChangeAccessRights(true)}>Rechte ändern</button>
                            <button type="button" className="light" onClick={() => setChangePassword(true)} title="Passwort ändern" style={{padding: "10px 15px"}}>
                                <LockResetRoundedIcon />
                            </button>
                        </div>
                    </div>
                </EditModal>
            )}

            {changePassword && (
                <ChangePassword
                    userId={item.id}
                    onClose={() => setChangePassword(false)}
                />
            )}

            {changeAccessRights && (
                <ChangeUserPermissions
                    id={item.id}
                    onClose={() => setChangeAccessRights(false)}
                />
            )}
        </div>
    )
};

export default Users